import { ApiEndpoints } from "api/endpoints";
import { makeMutation } from "api/api";
import * as z from "zod";
import { TFunction } from "i18next";
import { generalErrorCodes } from "shared/errors/generalErrorCodes";

const AcceptInvitationSchema = z.object({
  success: z.literal(true),
});

export interface MutateAcceptInvitationParams {
  id: number;
  token: string;
  password: string;
  isMarketingConsent: boolean;
}

export const mutateAcceptInvitation = async (values: MutateAcceptInvitationParams) => {
  const response = await makeMutation(ApiEndpoints.userAcceptInvitation(), values, false, 'POST', acceptInvitationErrorCodes);
  return AcceptInvitationSchema.parse(response);
};

export const acceptInvitationErrorCodes = {
  ...generalErrorCodes,
  NOT_FOUND: {
    code: "NOT_FOUND",
    translation: (t: TFunction) => t("Invitation expired"),
  },
  INVALID_ACTIVATION_TOKEN: {
    code: "INVALID_ACTIVATION_TOKEN",
    translation: (t: TFunction) => t("Invitation expired"),
  },
};
